import { useRef } from 'react';
import { industries } from '../data';

export default function Industries() {
  const scroller = useRef(null);

  const scrollByCard = (direction) => {
    const node = scroller.current;
    if (!node) return;
    node.scrollBy({ left: direction * Math.round(node.clientWidth * 0.72), behavior: 'smooth' });
  };

  return (
    <section className="section industries" id="industries">
      <div className="container">
        <div className="section-head with-controls" data-reveal>
          <div>
            <h2 className="display-2">
              Built around <em>how you work.</em>
            </h2>
            <p className="section-lede">
              Thoughtful financial support for the people building work they’re proud of.
            </p>
          </div>
          <div className="scroll-controls">
            <button type="button" onClick={() => scrollByCard(-1)} aria-label="Scroll cards left">
              <span aria-hidden="true">←</span>
            </button>
            <button type="button" onClick={() => scrollByCard(1)} aria-label="Scroll cards right">
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>

      <div
        className="industry-scroller"
        ref={scroller}
        tabIndex={0}
        role="group"
        aria-label="Industries we work with — scroll horizontally to see more"
      >
        {industries.map((industry) => (
          <article className="industry-card" key={industry.name}>
            <img src={industry.image} alt={industry.name} loading="lazy" />
            <div className="industry-body">
              <h3>{industry.name}</h3>
              <p>{industry.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
